import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import * as api from '../../../shared/api/apihandler';

@Component({
  selector: 'upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css']
})
export class UploadFileComponent implements OnInit {

  @Input() currentPath: string;
  @Output() files = new EventEmitter<any>();

  addFileHover;

  constructor(private http: HttpClient, private toastr: ToastrService, private translate: TranslateService) { }

  ngOnInit(): void {
  }

  async addFiles(event) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    let count = 0;
    if (event.target.files.length > 0) {
      for (let f of event.target.files) {
        count += 1;
        await this.upload(f).subscribe(
          (res: any) => {
           this.files.emit(res)
          },
          (err) => {
            if (err.status == 413) {
              this.toastr.error(f.name, this.translate.instant('Error.FileTooBig'));
            }
          }
        )
      }
    }
  }


  upload(fileToUpload:any) {
    let input = new FormData();
    input.append("file", fileToUpload);
    let fileAccessId = "4D32156A-20FE-4601-8CC8-0A4711034D6B";
    let path = encodeURIComponent(this.currentPath);
    return this.http.post(api.jubloApi + 'api/shared/attachments/FileWithPath?fileAccessId=' + fileAccessId + "&path=" + path, input);
  }
}
